import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/works', label: 'Works' },
  { to: '/blog', label: 'Blog' },
  // { to: '/process', label: 'Process' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isLinkActive = (to) =>
    location.pathname === to || (to !== '/' && location.pathname.startsWith(to));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50 px-10 md:px-16 lg:px-20
        flex items-center justify-between h-16
        transition-all duration-300
        ${scrolled
          ? 'bg-[#FFFBEA]/95 backdrop-blur-sm border-b border-cream-400/60'
          : 'bg-[#FFFBEA] backdrop-blur-0 border-b border-cream-400/60'
        }
      `}
    >
      <Link
        to="/"
        className="font-serif text-[20px] tracking-wide hover:opacity-70 transition-opacity text-ink"
      >
        Ananya Kedlaya
      </Link>

      <div className="hidden md:flex items-center gap-10">
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className={
              `label transition-colors duration-200 ${isLinkActive(to)
                ? 'text-ink after:block after:h-px after:w-full after:bg-ink after:mt-1'
                : 'text-[#8B8000] hover:text-ink'}`
            }
          >
            {label}
          </Link>
        ))}
      </div>

      <button
        className="md:hidden flex flex-col gap-1.5 p-1"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`block w-5 h-px transition-all duration-200 ${menuOpen ? 'rotate-45 translate-y-2' : ''} bg-ink`} />
        <span className={`block w-5 h-px transition-all duration-200 ${menuOpen ? 'opacity-0' : ''} bg-ink`} />
        <span className={`block w-5 h-px transition-all duration-200 ${menuOpen ? '-rotate-45 -translate-y-2' : ''} bg-ink`} />
      </button>

      {menuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 border-b px-10 py-8 flex flex-col gap-6 bg-cream-100 border-cream-400/60">
          {links.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={
                `label text-base ${isLinkActive(to) ? 'text-ink' : 'text-stone-muted'}`
              }
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
